import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-updated">Last updated: <strong>22 December 2025</strong></p>

        <p className="privacy-intro">
          Welcome to <strong>TripPrizer</strong>. Your privacy is important to us, and this Privacy
          Policy explains how we collect, use, disclose, and protect your information when you use
          our website, mobile application, or services related to online tourism, travel bookings,
          and trip planning.
        </p>

        <p className="privacy-intro">
          By accessing or using TripPrizer, you agree to the practices described in this Privacy Policy.
        </p>

        <section>
          <h2>1. Information We Collect</h2>

          <h3>a. Personal Information</h3>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Billing and payment details</li>
            <li>Travel preferences and booking details</li>
            <li>Government-issued ID details (only if required for bookings)</li>
          </ul>

          <h3>b. Non-Personal Information</h3>
          <ul>
            <li>IP address</li>
            <li>Browser type and device information</li>
            <li>Pages visited and time spent on our website</li>
            <li>Cookies and usage data</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Process travel bookings and payments</li>
            <li>Provide customer support and travel assistance</li>
            <li>Personalize travel recommendations and offers</li>
            <li>Send booking confirmations, updates, and promotional communications</li>
            <li>Improve our website, services, and user experience</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>
        </section>

        <section>
          <h2>3. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance website functionality, analyze user
            behavior, and remember user preferences.
          </p>
          <p>
            You can choose to disable cookies through your browser settings; however, some features
            of TripPrizer may not function properly.
          </p>
        </section>

        <section>
          <h2>4. Sharing of Information</h2>
          <p>We do not sell your personal information. We may share your data with:</p>
          <ul>
            <li>Travel partners such as hotels, airlines, tour operators, and payment gateways</li>
            <li>Service providers who assist us in operating our platform</li>
            <li>Legal authorities if required by law or to protect our rights</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            TripPrizer implements appropriate technical and organizational security measures to
            protect your personal data. However, no method of transmission over the internet is
            100% secure.
          </p>
        </section>

        <section>
          <h2>6. Your Rights and Choices</h2>
          <ul>
            <li>Access, update, or correct your personal information</li>
            <li>Request deletion of your data (subject to legal obligations)</li>
            <li>Opt out of marketing communications at any time</li>
          </ul>
        </section>

        <section>
          <h2>7. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party travel or service websites. TripPrizer is
            not responsible for their privacy practices or content.
          </p>
        </section>

        <section>
          <h2>8. Children’s Privacy</h2>
          <p>
            TripPrizer does not knowingly collect personal information from children under the age
            of 13. If such data is identified, it will be removed promptly.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            TripPrizer reserves the right to update this Privacy Policy at any time. Changes will be
            posted on this page with an updated effective date.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <div className="contact-box">
            <p><strong>TripPrizer</strong></p>
            <p>Email: info@tripprizer.com</p>
            <p>Phone: +91-9216751025</p>
            <p>Address: Simroze Building, 2, Ferozedin Road, Below Hussainpura Bridge, Near Bus Stand, Amritsar, Punjab 143001</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
